import React,{Component} from "react";
import logo from "./images/loading.gif";
import Table from 'react-bootstrap/Table'
import modallogo from "./images/loader.gif";
import Modal from "react-bootstrap/Modal"
import Cookies from "universal-cookie";

const axios = require("axios");
const ref = React.createRef();
const cookies=new Cookies();
const formdata = new FormData;
class AdminNews extends Component{
    constructor(props)
    {
        super(props);
           this.state={isValid:true,earray:[],input:{},ref:"",UbuttonED:true,RbuttonED:true,savealert:"",removealert:"",value:0,tab1:"block",tab2:"none",tab3:"none",myitems:[],bdisabled:true,isLoaded:true,inputkey:Date.now() ,errorprofile:"",errors:{},error:"",ErrMsg:<img src={logo} alt=""/>,errorcss:"labelerror",filetoupload:null,filename:null,browsecss:"labelblock",savecss:"labelnone",cancelcss:"labelnone",isOpen:false};
           this.handletable = this.handletable.bind(this);
           this.handleSave = this.handleSave.bind(this);

        }
    
    handletable=(e)=>{
        if(e.target.checked)
            {    
                var items = this.state.earray.slice();    
                items.push(e.target.value);   
                this.setState({earray:items});                
            }
        else
            {
                var items = this.state.earray;
                var index = items.indexOf(e.target.value); // Let's say it's Bob.
                delete items[index];
                this.setState({earray:items});
            }
        
    }
    handleSave=()=>{
//        if(this.validate())
 //       {
        console.log(this.state.input);
        document.body.style.cursor="wait";
//        formdata.append("inputarray",this.state.input);
//        formdata.append("earray[]",this.state.earray);

//            var phpurl=cookies.get("phpclass")+"/index.php/user/SaveNews/";
 //           axios.post(phpurl,formdata, {
        axios({
            method:"post",
            url:cookies.get("phpclass")+"/index.php/user/SaveNews/",
            data:this.state.input,
            headers: {'Content-Type': 'multipart/form-data'}            
            })
            .then((res) => {
                console.log(res.data);
                if(res.data === 0)
                {
                    this.setState({savealert:"Email sent Successfully.",errorcss:"labelsave"});
                    document.body.style.cursor ="default";
                }
                else if(res.data === 2)
                {
                    this.setState({savealert:"Failed to sent email",errorcss:"labelerror"});
                    document.body.style.cursor ="default";
                }
                else if(res.data === -1)
                {
                    this.setState({savealert:"Failed to process",errorcss:"labelerror"});
                    document.body.style.cursor ="default";
                }
            })
            .catch((response)=> {
                document.body.style.cursor="default";
               //this.setState({errorprofile:response.error,errorcss:"labelerror",bdisabled:false});
           }); 
    }
    handleRemove=()=>{
        document.body.style.cursor="wait";
        axios({
            method:"post",
            url:cookies.get("phpclass")+"/index.php/user/removeNotification/"+this.state.ref,
            headers: {'Content-Type': 'multipart/form-data'}
        })
        .then((res)=>{
            document.body.style.cursor="default";
            if(res.data === 1)
                this.setState({savealert:"Record has been removed.",RbuttonED:true,UbuttonED:true});
            else
                this.setState({savealert:"Failed to remove."});
            })
        .catch(()=>{
            document.body.style.cursor="default";
            this.setState({savealert:"It might be connection error."});
        })
    }
    handleFileUploadR=()=> 
    {
        if(this.state.filetoupload !== null)
        {
            document.body.style.cursor ="wait";
            this.setState({isOpen:true});
            const formdata = new FormData() 
            formdata.append("myfile[]", this.state.filetoupload,this.state.filename);
            formdata.append("ref", this.state.input["rref"]);
            formdata.append("oldfile", this.state.input["filepath"]);

            axios.post(cookies.get("phpclass")+"/index.php/user/uploadFileR/",formdata, {
                }).then((res) => {
                if(res.data === 0)
                {
                    this.setState({uploadalert:"File uploaded",errorcss:"labelsave",isOpen:false});
                    this.setState({inputkey:Date.now(),filetoupload: "",filename: "",browsecss:"labelblock",savecss:"labelnone",cancelcss:"labelnone"});
                    document.body.style.cursor ="default";
                }
                else
                {
                    this.setState({uploadalert:"File upload failed",errorcss:"labelerror",isOpen:false});
                    document.body.style.cursor ="default";
                }
           })
        }
        else
        {
            this.setState({error:"Must select a file to upload",errorcss:"labelerror",isOpen:false});
            document.body.style.cursor ="default";
        }
    }

    Imagechange=(event)=>
    {
        this.setState({error:"",UbuttonED:false,filetoupload: event.target.files[0],filename: event.target.files[0].name,imagefile:URL.createObjectURL(event.target.files[0]),browsecss:"labeblock",savecss:"labelblock",cancelcss:"labelblock"});
    }
    Imagecancel=(event)=>
    {       
        this.setState({inputkey:Date.now(),error:"",filetoupload: "",filename: "",imagefile:this.state.defaultimage,browsecss:"labelblock",savecss:"labelnone",cancelcss:"labelnone"});
    }

    componentDidMount()
    {
/*        document.body.style.cursor="wait";
        axios({
            method: 'post',
            url: cookies.get("phpclass")+"/index.php/user/GetDocuments/",
            headers: {'Content-Type': 'multipart/form-data'}
            })

            .then((response)=> {
                 document.body.style.cursor="default";
                 if(response.data === 0)
                    this.setState({isValid :false });
                else
                    this.setState({myitems:response.data,isValid:true});
            })
            .catch((response)=> {
                 document.body.style.cursor="default";
            }); 
*/            
    }

    //Change of input fields
    handleFieldsChangeR=(event)=>
    {
        let itemvalue=event.target.value;
        let input = this.state.input;
        if(event.target.name=="rdesc")
        {
            var descvalue=itemvalue.replace(/'/gi,"''");
            input["desc2"]=descvalue;
        }
       input[event.target.name]=event.target.value;
       this.setState({input});      
    }

    //Change of input fields
    handleFiledsChange=(event)=>
    {
        let input = this.state.input;
        input[event.target.name]=event.target.value;
        this.setState({input});      
    }

  
    validate(){
        let input = this.state.input;
        let errors = {};
        let isValid = true;
        //For email
        if (input["rtitle"].length == 0 ) {      
            isValid = false;
            errors["rptitle"] = "Please enter title.";          
        }                
        if (input["rdesc"].length == 0) {      
            isValid = false;
            errors["rpdesc"] = "Please enter description.";
        }                
      this.setState({errors: errors});
        return isValid;
    }        
    render(){
    
        let items = this.state.myitems;
        let isLoaded = this.state.isLoaded;
    
        if(!isLoaded) 
        {
            return (
                
                <div className="container1">            
                    <div className="center">
                          {this.state.ErrMsg}
                    </div>
                </div>
            )
        } 
        else 
        {
        return(

        <div className="containera1">
        <br></br><br></br>           
                <div width="100%" align="center" height="100%" scroll="hidden" >
                        <div className="inner-profile" >
                            <span className="box-title">News and Notifications</span>
                            <div className="inner-profile2" >
                                {/*<div className="form-group row">
                                    <br></br>
                                    <div style={{width:"100%",maxHeight:"400px" }}>
                                        <Table striped bordered hover variant="dark">
                                            <thead>
                                            <tr>
                                                <th style={{width:"5%",padding:"5px 2px 5px 5px"}} >#</th>
                                                <th style={{width:"25%",padding:"5px 2px 5px 5px"}}>Reference#</th>
                                                <th style={{width:"20%",padding:"5px 2px 5px 5px"}}>Date</th>
                                                <th style={{width:"40%",padding:"5px 2px 5px 5px"}}>Title</th>
                                                <th style={{width:"10%",padding:"5px 2px 5px 5px"}}>Status</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            {!this.state.isValid && items.map((result, i)=>{
                                            return(
                                                <tr key={i} >
                                                    <td style={{height:"10px",padding:"2px 2px 2px 5px"}}>{i+1}</td>
                                                    <td style={{height:"10px",padding:"2px 2px 2px 5px"}}>{result.ref}</td>
                                                    <td style={{height:"10px",padding:"2px 2px 2px 5px"}}>{result.pdate}</td>
                                                    <td style={{height:"10px",padding:"2px 2px 2px 5px"}}>{result.title}</td>
                                                    <td style={{height:"10px",padding:"2px 2px 2px 5px"}}><input type="checkbox" onClick={this.handletable} value={result.ref}></input></td>
                                                </tr>
                                            );
                                            })}
                                            </tbody>
                                        </Table>
                                    </div>
                                        </div>*/}
{/*                                <form accept-charset="ISO-8859-1">                                */}
                                    <div className="form-group row">
                                        <br></br>
                                        <label>Reference#:</label>
                                        <input type="text" name="rref" onBlur={this.handleFieldsChangeR} className="form-control" />
                                        <label>From:</label>
                                        <input type="text" name="from" disabled className="form-control" value="hr@poultry-kandns.com" onBlur={this.handleFieldsChangeR}/>
                                        <label>CC:</label>
                                        <input type="text" name="cc"  className="form-control" onBlur={this.handleFieldsChangeR}/>
                                        <label>Subject:</label>
                                        <input type="text" name="rtitle"  className="form-control" onBlur={this.handleFieldsChangeR}/>
                                        <small id="rptitle" className="text-danger">{this.state.errors.rptitle}</small>
                                    </div>
                                    <div className="form-group row">
                                        <label>Body (use comma to sperate the multiple addresses):</label>
                                        <textarea rows={10} name="rdesc"  cols={100} className="form-control" onBlur={this.handleFieldsChangeR}/>
                                        <small id="rptitle" className="text-danger">{this.state.errors.rpdesc}</small>
                                        <label className={this.state.errorcss}>{this.state.savealert}</label>

                                        <button
                                            className=".btn btn-secondary btn-sm"
                                            onClick={this.handleSave}
                                            style={{alignSelf:"right",width:"75px"}}
                                        >
                                            Send
                                        </button>


                                    </div>
{/*}                                </form>*/}

                            </div>

  {/*}                          <div style={{width:"55%",float:"left",marginLeft:"0px",textAlign:"left",border:"1px"}} >

                                <input
                                    type="text"
                                    className="form-control"
                                    name="rrmyfile"
                                    disabled
                                    value={this.state.input["filepath"]}
                    
                                    />
                                    <label className="labelerror" >
                                        <span className={this.state.errorcss}>{this.state.error}</span>
                                    </label>
                                        </div>*/}
                            <div style={{width:"20%",float:"left"}}>
                            <span className={this.state.errorcss}>{this.state.removealert}</span>
                            </div>


                        </div>
                    </div>
                    <Modal show={this.state.isOpen} onHide={this.onhideModal} animation="false" centered backdrop="static" size="sm">
                        <Modal.Body><img src={modallogo} width="30px" height="30px"/><span style={{PaddingLeft:"15px"}}>Please wait...</span></Modal.Body>
                    </Modal>

                </div>

    )}
}}
export default AdminNews;